import {
  CertificateType,
  CertificateValueBorn,
} from 'front-office/view-models/document-birth-form';

const initialValues = {
  fiscalCode: '',
  surname: '',
  withoutSurname: false,
  name: '',
  withoutName: false,
  gender: '',
  birthDate: null,
  municipality: null,
  isForeign: false,
  foreignState: null,
  documentNumber: '',
  documentIssuedDate: null,
  foreignMunicipality: null,
  isForeignDocument: false,
  certificate: {
    type: CertificateType.nascita,
    value: CertificateValueBorn.copia,
  },
  selectedCertificate: 'COPIACONFORME',
  municipalityDocument: null,
  foreignStateDocument: '',
  file: undefined,
  raw: [],
  rawTiff: '',
  copies: '1',
  timber: '',
  timberFreeText: '',
  reason: '',
  reasonRelease: '',
  chosenDocument: null,
  documentSearch: {
    page: 0,
    rowsPerPage: 10,
    orders: {},
    year: '',
    document: '',
    registry: null,
    portion: '',
    serie: '',
    matricolaHusband: '',
    surnameHusband: '',
    nameHusband: '',
    matricolaWife: '',
    surnameWife: '',
    nameWife: '',
    operationYear: '0',
    operationDocument: '0',
    operationRegistry: '0',
    operationPortion: '0',
    operationSerie: '0',
    operationMatricolaHusband: '0',
    operationSurnameHusband: '0',
    operationNameHusband: '0',
    operationMatricolaWife: '0',
    operationSurnameWife: '0',
    operationNameWife: '0',
    typePayment: '',
  },
};

export default initialValues;
